export class ProtocolAndBaseUrl {
    public constructor(public protocol: string, public baseurl: string) {
    }
}

export class ProtocolAndBaseUrlUtil {
    public static getProtocolAndBaseUrl(): ProtocolAndBaseUrl {
        let baseurl = window.location.origin;
        let protocol = "https:";
        if (baseurl.indexOf("//") > 0) {
            protocol = baseurl.split("//")[0];
            baseurl = baseurl.split("//")[1];
        }

        return new ProtocolAndBaseUrl(protocol, baseurl);
    }
}
